/**
 * DiagnosisUnlock Loading hero「i」图标 — Figma `90772:39831` Group 2147235200。
 *
 * 与通用 Onboarding Loading `88963:41286`（120×56，圆 56px）**不是同一套尺寸**。
 */
export const DIAGNOSIS_UNLOCK_LOADING_HERO_FIGMA = {
  group: "90772:39831",
  ellipse: "90772:39832",
  body: "90772:39833",
} as const;

/** 容器 37.333 × 80 */
export const DIAGNOSIS_UNLOCK_LOADING_HERO_LAYOUT = {
  widthPx: 37.333,
  heightPx: 80,
  /** 圆 — Ellipse 37.333 × 37.333 */
  headSizePx: 37.333,
  /** 方 — Frame 34.667 × 34.667，top 45.333 → 与圆间距 8px */
  bodySizePx: 34.667,
  bodyTopPx: 45.333,
  bodyLeftPx: 1.333,
  bodyRadiusPx: 2,
} as const;
